import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHookstate } from "@hookstate/core";
import {
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { PEOPLE_SERVICES } from "redux/reduxToolkitServices/_commonServices/peopleServices";
import '@progress/kendo-theme-default/dist/all.css';
import {
    ModalTitle,
    ModalButton,
} from "pages/People/PeopleStyled";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import PeopleAlertModal from "../peopleAlertModal";

const AddGroupModal = React.memo(({setIsLoading,
                                    addGroupModalOpen,
                                    setAddGroupModalOpen }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [groupName, setGroupName] = useState("");
    const [shouldSaveAddButtonBeDisabled, setShouldSaveAddButtonBeDisabled] = useState(true);
    const [openPeopleDiscardChangesModalOpen, setOpenPeopleDiscardChangesModalOpen] = useState(false);

    const addGroup = () => {
        if(groupName.length > 1) {   
            let request = {
                groupName: groupName,
                siteId: siteId.get(),
                Inactivated: false
            };

            dispatch(PEOPLE_SERVICES.saveGroupService(siteId.get(), request));

            closeAddPersonModal();
            setIsLoading(true);
        }
    }

    const closeAddPersonModal = () => {
        setGroupName("");
        setAddGroupModalOpen(false);
        setShouldSaveAddButtonBeDisabled(true);
        setOpenPeopleDiscardChangesModalOpen(false);
    }

    const openPeopleDiscardChangesModal = () => {
        if(groupName != "") {
            setOpenPeopleDiscardChangesModalOpen(true);
        } else {
            closeAddPersonModal();
        }
    }

    const closeAlertModal = () => {
        setOpenPeopleDiscardChangesModalOpen(false);
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#ffffff',
        border: '2px solid #ccc',
        boxShadow: 24,
        p: 4,
    };

    const input = {
        width: '100%', 
        height: 38, 
        border: 'solid 1px #ccc' 
    }

    return (<>  
                <Modal 
                    open={addGroupModalOpen}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description">
                        <Box sx={modalStyle}>
                        <ModalTitle>
                                <div>{t("Add_New_Group")}</div>

                                <div style={{display: 'flex', justifyContent: 'flex-end', cursor: 'pointer'}} onClick={openPeopleDiscardChangesModal}>
                                    <ModalCloseIcon width={18} height={18} color="#fff" />
                                </div>
                            </ModalTitle> 

                            <div style={{ flex: 1 }}>
                                <div>{t("Group_Name")}</div>
                                <input type="text" value={groupName} onChange={(e) => { setGroupName(e.target.value); setShouldSaveAddButtonBeDisabled(false)}} style={input} />
                            </div>

                            <ModalButton>
                                <button 
                                    onClick={openPeopleDiscardChangesModal} 
                                    style={{ marginRight: 10, height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc' }}>
                                        {t("Cancel")}
                                </button>
                                <button 
                                    disabled={shouldSaveAddButtonBeDisabled}
                                    onClick={addGroup}
                                    style={shouldSaveAddButtonBeDisabled ? { height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc', cursor: "not-allowed	"  } : { height: 35, padding: 10, backgroundColor: '#bc9b6a', color: 'white', border: 'solid 1px #ccc' }}>
                                        {t("Save")}
                                </button>
                            </ModalButton>
                        </Box>
                </Modal>
                <PeopleAlertModal
                                 openPeopleAlertModalOpen={openPeopleDiscardChangesModalOpen} 
                                 yesCallbackFunction={() => closeAddPersonModal()}
                                 noCallbackFunction={() => closeAlertModal()}
                                 title={t("Confirm_cancel")}
                                 content={t("Are_You_Sure_You_Want_To_Discard_Changes") + "?"} 
                                 loading={false}
                                 isMessageOnly={false} />
        </> 
    );
});

export default AddGroupModal;